module.exports = __webpack_public_path__ + "img/emo_55.f24d53de.gif";